import { AnimatePresence, m } from 'framer-motion';
import { WifiOff } from 'lucide-react';
import { useUiStore } from '@/store/uiStore';

/**
 * Глобальная плашка отсутствия сети.
 * Не блокирует интерфейс: сохранённые данные остаются доступными.
 */
export function OfflineBanner() {
  const isOnline = useUiStore((state) => state.isOnline);

  return (
    <AnimatePresence>
      {isOnline ? null : (
        <m.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          role="status"
          className="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 bg-brand-deep px-4 py-2 text-[12px] text-white"
          style={{ paddingTop: 'calc(8px + var(--bd-safe-top))' }}
        >
          <WifiOff className="h-3.5 w-3.5" aria-hidden />
          Нет подключения к интернету
        </m.div>
      )}
    </AnimatePresence>
  );
}
